import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import AuthAutoRedirect from "./routes/AuthAutoRedirect";

function App() {
  return (
    <AuthProvider>
      <Router>
        <AuthAutoRedirect />
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
